import http from '@/http.js'
import store from '@/store'

export default class CompanyService {
  SaveSymbol (symbol) {
    return new Promise((resolve, reject) => {
      http.post(`/api/symbol`, symbol)
      .then((response) => { 
        store.commit('AddOrUpdateSymbol', response.data.data)
        resolve(response.data.data) 
      })
      .catch((error) =>  reject(error))
    })    
  }

  Resume (symbol) {
    return new Promise((resolve, reject) => {
      http.get(`/api/symbol/${symbol}/resume`)
      .then((response) => { resolve(response.data) })
      .catch((error) =>  reject(error))
    })
  }

  GetSymbol (symbol) {
    return new Promise((resolve, reject) => {
      http.get(`/api/symbol/${symbol}`)
      .then((response) => { resolve(response.data.data) })
      .catch((error) =>  reject(error))
    })
  }  

  GetDistinctSymbols () {
    return new Promise((resolve, reject) => {
      http.get(`/api/transaction/symbols/distinct`)
      .then((response) => { resolve(response.data) })
      .catch((error) => reject(error))
    })
  }

  ConsultPrice (symbol) {
    return new Promise((resolve, reject) => {
      http.get(`/api/symbol/${symbol}/marketprice`)
      .then((response) => { resolve(response.data) })
      .catch((error) => reject(error))
    })
  }
    
  GetCompanysTable () {
    return new Promise((resolve, reject) => {
      http.get(`/api/companys/table`)
      .then((response) => { 
        store.commit('SetCompanys', response.data)
        resolve(response.data) 
      })
      .catch((error) => reject(error))
    })
  }

  GetSymbolsTable () {
    return new Promise((resolve, reject) => {
      http.get(`/api/symbols/table`)
      .then((response) => { 
        store.commit('SetSymbols', response.data)
        resolve(response.data) 
      })
      .catch((error) => reject(error))
    })    
  }

  AnnouncedDividends (symbol) {
    return new Promise((resolve, reject) => {
      http.get(`/api/dividends/${symbol}/announced`)
      .then((response) => { 
        resolve(response.data.data) 
      })
      .catch((error) => reject(error))
    })        
  }
}